import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import settingsIcon from '../../../../images/icons/settings.svg';
import moment from 'moment-timezone';
import { SetComponentLanguage, ApiRequest, ReturnTimeZone } from '../../../../helpers';
import { DymoPrint } from '../../../../lib/labels/DYMO.print';
import Boca from '../../../../lib/labels/boca';
import Star from '../../../../lib/labels/star';
import AlertModal from '../../../Common/AlertModal/AlertModal';
import AlertModalStar from '../../../Common/AlertModalStar/AlertModalStar';
import LocalizedStrings from 'react-localization';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import printIcon from '../../../../images/icons/print.svg';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class EventDates extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isModalOpen: false,
            isModalOpenBoca: false,
            isModalOpenStar: false,
            event_date_id: null,
            currentIndex: '',
            currentPrinterStar: '',
        }
    }

    toggleAlertModal = (e, date) => {
        e.preventDefault();
        this.setState({
            isModalOpen: !this.state.isModalOpen,
            date,
        });
    }

    toggleAlertModalBoca = (e, date) => {
        e.preventDefault();
        this.setState({
            isModalOpenBoca: !this.state.isModalOpenBoca,
            date,
        });
    }

    toggleAlertModalStar = (e, date) => {
        e.preventDefault();
        if (this.props.currentPrinterStar === '') {
            this.setState({
                isModalOpenStar: !this.state.isModalOpenStar,
                date,
            });
        } else {
            console.log('printTransactionStarTickets');
            this.printWillCallTicketsStar(date.id);
        }
    }

    confirmAlertModalStar = () => {
        if(!localStorage.getItem("defaultStarPrinter")) {
            localStorage.setItem('defaultStarPrinter', localStorage.getItem("printersStar")[0]);
            this.setState({
                currentPrinterStar: localStorage.getItem("printersStar")[0]
            });
        }
        this.setState({
            isModalOpenStar: false
        }, () => this.printWillCallTicketsStar(this.state.date.id));
    }

    setCurrentIndex = (index) => {
        const currentIndex = index;
        this.setState({ currentIndex });
    }

    handleClick = (e) => {
        if (this.node && this.node.contains(e.target) || 
                e.target.id === `dates-settings-b-${this.props.event.id}-${this.state.currentIndex}` || 
                    e.target.id === `dates-settings-i-${this.props.event.id}-${this.state.currentIndex}`) {
            return;
        }
        // Keep submenu open when clicking on House Count button
        if(e.target.name !== 'house-count-button') {
            this.handleClickOutside();
        }
    }

    handleClickOutside = () => {
        if (this.props.event.event_dates.some((date) => date.isDateSettingsOpen === true)) {
            const id = this.props.event.id;
            this.props.toggleDateSettings(id);
        }
    }

    confirmAlertModal = () => {
        this.setState(
            {
                isModalOpen: false
            },
            () => {
                this.printWillCallTicketsDymo();
            }
        );
    }

    confirmAlertModalBoca = () => {
        this.setState(
            {
                isModalOpenBoca: false
            },
            () => {
                this.printWillCallTicketsBoca();
            }
        );
    }

    printWillCallDymoPDF = async(date) => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/event-dates/${date.id}/print-will-call/dymo`);
    }

    printWillCallTicketsDymo = async () => {
        try {
            const response = await printWillCallDymo(this.state.date.id);

            const client = {};
            client['client_name'] = this.props.client_name;

            if (!response.data.error) {
                response.data.transactions.forEach(transaction => {
                    const { tickets, customer } = transaction;
                    transaction.tickets.map(ticket => {
                        ticket['event_date'] = {};
                        ticket['event_date']['event_datetime'] = this.state.date.event_datetime;
                        ticket['event_date']['event_datetime_local'] = this.state.date.event_datetime_local;

                        ticket['event'] = {};
                        ticket['event']['name'] = this.props.event.name;

                        ticket['venue'] = {};
                        ticket['venue']['name'] = this.props.event.venue.name;
                        ticket['venue']['address'] = this.props.event.venue.address;
                        ticket['venue']['venue_type'] = this.props.event.venue.venue_type;                        
                    });
                    DymoPrint(this.props.currentPrinter, 'ticket', tickets, client, customer);
                })
            } else {
                this.props.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                setTimeout(() => {
                    this.props.setMessage('', '', '');
                }, 3000);
            }
        } catch (error) {
            window.scrollTo(0, 0);
            console.log(error);
            this.props.setMessage(window.general_strings.msg.oops, error, 'error');
            setTimeout(() => {
                this.props.setMessage('', '', '');
            }, 3000);
        }

        async function printWillCallDymo(event_date_id) {
            return await ApiRequest(`/event-dates/${event_date_id}/will-call`, {
                method: 'GET'
            });
        }
    }

    printWillCallTicketsBoca = async (date) => {
        let dateId = date ? date.id : this.state.date.id;
        const _this = this;
        const client_name = this.props.client_name;
        const event = this.props.event;
        try {
            const response = await printWillCallBoca(dateId);

            const client = {};
            client['client_name'] = client_name;

            let customer = {};

            if (!response.data.error) {
                let tickets = [];
                response.data.transactions.map(transaction => {
                    transaction.tickets.map(ticket => {
                        ticket['event_date'] = {};
                        //ticket['event_date']['event_datetime'] = response.data.event_date.event_datetime;
                        ticket['event_date']['event_datetime_local'] = response.data.event_date.event_datetime_local;

                        ticket['event'] = {};
                        ticket['event']['name'] = event.name;

                        ticket['venue'] = {};
                        ticket['venue']['name'] = event.venue.name;
                        ticket['venue']['address'] = event.venue.address;
                        ticket['venue']['city'] = event.venue.city;
                        ticket['venue']['state'] = event.venue.state;
                        ticket['venue']['zip'] = event.venue.zip;
                        ticket['venue']['venue_type'] = event.venue.venue_type;

                        ticket['customer'] = transaction.customer;
                        customer = transaction.customer;

                        tickets.push(ticket);
                    })
                });
                let boca = new Boca();
                //boca.printFGL(_this.props.currentPrinterBoca, 'ticket', tickets, client, customer);
                boca.printFGL('Boca 1', 'ticket', tickets, client, customer);

            } else {
                _this.props.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                setTimeout(() => {
                    _this.props.setMessage('', '', '');
                }, 3000);
            }
        } catch (error) {
            window.scrollTo(0, 0);
            console.log(error);
            _this.props.setMessage(window.general_strings.msg.oops, error, 'error');
            setTimeout(() => {
                _this.props.setMessage('', '', '');
            }, 3000);
        }

        async function printWillCallBoca(event_date_id) {
            return await ApiRequest(`/event-dates/${event_date_id}/will-call`, {
                method: 'GET'
            });
        }
    }

    printWillCallTickets = async (event_date_id) => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/event-dates/${event_date_id}/print-will-call`);
    }

    printerSelectStar = () => {
        return (
            <React.Fragment>
                <div className="showtix-form__group">
                    <div className="showtix-form__select">
                        {this.props.printersStar.length > 0 ? (
                                <select className="showtix-input"
                                    value={this.props.currentPrinterStar}
                                    onChange={this.props.handlePrinterChangeStar}
                                >
                                    <option>Select</option>
                                    {this.props.printersStar.map((printer, i) => (
                                        <option value={this.props.printersStar[i].ip_address}>{this.props.printersStar[i].name} ({this.props.printersStar[i].ip_address})</option>
                                    ))}
                                    <option value='http://localhost:8001'>SM-S230i</option>
                                </select>
                            ) : (
                                <select className="showtix-input"
                                    value={this.props.currentPrinterStar}
                                    onChange={this.props.handlePrinterChangeStar}
                                >
                                    <option>Select</option>
                                    <option value='http://localhost:8001'>SM-S230i</option>
                                </select>
                            )
                        }
                    </div>
                </div>
                {this.props.printersStarUSB.length > 0 && (
                    <React.Fragment>
                        USB Printers:
                        <div className="showtix-form__group">
                            <div className="showtix-form__select">
                                {this.props.printersStarUSB.length > 0 && (
                                    <select className="showtix-input"
                                        value={this.props.currentPrinterStar}
                                        onChange={this.props.handlePrinterChangeStar}
                                    >
                                        <option>Select</option>
                                        {this.props.printersStarUSB.map((printer, i) => (
                                            <option value={this.props.printersStarUSB[i].name}>{this.props.printersStarUSB[i].name}</option>
                                        ))}
                                    </select>
                                )}
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
            
        );
    }

    printWillCallTicketsStar = async (date_id) => {
        const _this = this;
        const client_name = this.props.client_name;
        const event = this.props.event;
        try {
            const response = await printWillCallStar(date_id);

            const client = {};
            client['client_name'] = client_name;

            let customer = {};

            if (!response.data.error) {
                let tickets = [];
                response.data.transactions.map(transaction => {
                    transaction.tickets.map(ticket => {
                        ticket['event_date'] = {};
                        //ticket['event_date']['event_datetime'] = response.data.event_date.event_datetime;
                        ticket['event_date']['event_datetime_local'] = response.data.event_date.event_datetime_local;

                        ticket['event'] = {};
                        ticket['event']['name'] = event.name;

                        ticket['venue'] = {};
                        ticket['venue']['name'] = event.venue.name;
                        ticket['venue']['address'] = event.venue.address;
                        ticket['venue']['city'] = event.venue.city;
                        ticket['venue']['state'] = event.venue.state;
                        ticket['venue']['zip'] = event.venue.zip;
                        ticket['venue']['venue_type'] = event.venue.venue_type;

                        ticket['customer'] = transaction.customer;
                        customer = transaction.customer;

                        tickets.push(ticket);
                    })
                });
                let star = new Star();
                let isStarUSB = !localStorage.getItem('defaultStarPrinter').includes('http');
                if (isStarUSB) {
                    star.printFGLUSB(localStorage.getItem('defaultStarPrinter'), 'ticket', tickets, client, customer);
                } else {
                    star.printFGL('ticket', tickets, client, customer);
                }
            } else {
                _this.props.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                setTimeout(() => {
                    _this.props.setMessage('', '', '');
                }, 3000);
            }
        } catch (error) {
            window.scrollTo(0, 0);
            console.log(error);
            _this.props.setMessage(window.general_strings.msg.oops, error, 'error');
            setTimeout(() => {
                _this.props.setMessage('', '', '');
            }, 3000);
        }

        async function printWillCallStar(event_date_id) {
            return await ApiRequest(`/event-dates/${event_date_id}/will-call`, {
                method: 'GET'
            });
        }
    }

    renderDate = (date, i) => {
        let timezone = this.props.event.venue ? ReturnTimeZone(this.props.event.venue.timezone || 'EST') : 'EST';
        if (timezone === 'Please select') {
            timezone = 'EST';
        }
        //let timeStringSaleStart = date.sale_start.substring(0, 16).replace('T', ' ');
        //let timeStringSaleEnd= date.sale_end.substring(0, 16).replace('T', ' ');

        //let timeStringPreSaleStart = undefined;
        //if (date.presale_start) {
        //    timeStringPreSaleStart = date.presale_start.substring(0, 16).replace('T', ' ');
        //}

        //let timeStringPreSaleEnd = undefined;
        //if (date.presale_end) {
        //    timeStringPreSaleEnd = date.presale_end.substring(0, 16).replace('T', ' ');
        //}
        //let timeStringBoxOfficeSaleEnd= date.sale_end_box_office.substring(0, 16).replace('T', ' ');
        let venueDateTimeUTCSaleStart = moment(date.sale_start).tz(timezone);//moment.tz(timeStringSaleStart, timezone);
        let venueDateTimeUTCSaleEnd = moment(date.sale_end).tz(timezone);//moment.tz(timeStringSaleEnd, timezone);
        //let venueDateTimeUTCPreSaleStart = moment.tz(timeStringPreSaleStart, timezone).utc();
        //let venueDateTimeUTCPreSaleEnd = moment.tz(timeStringPreSaleEnd, timezone).utc();
        let venueDateTimeUTCBoxOfficeSaleEnd = moment(date.sale_end_box_office).tz(timezone);//moment.tz(timeStringBoxOfficeSaleEnd, timezone).utc();
        let localUTC = moment().utc();
        let dateString = '';
        if (date.event_datetime_local) {
            if (moment(date.event_datetime_local).tz(timezone)) {
                dateString = moment(date.event_datetime_local.substring(0, 19)).format('LLLL').toString();
            }
        }
        let dateLabel = (this.props.event.event_type === 'Event' || this.props.event.event_type === 'Live Stream' ||  this.props.event.event_type === 'Scheduled Content') ? dateString : strings.clickToPurchase;
        if (this.props.event.event_type === 'Video On Demand') {
            dateLabel = strings.clickToRent;
        }

        if (this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') {
            var timeZoneOffset = new Date(date.event_datetime_local).getTimezoneOffset();
            /* let timezone = 'EST';
            if (this.props.event.venue) {
                timezone = this.props.event.venue.timezone;
            } */
            dateLabel += '<span>(' + moment.tz.zone(timezone).abbr(timeZoneOffset) + ')</span>';
        }
        //console.log(moment.tz.zone(this.props.event.venue.timezone).abbr(new Date()))


        //console.log('dateString', dateString)


        if((this.props.user.role === 'client' || this.props.user.role === 'box-office')) {
            if (!localUTC.isBefore(venueDateTimeUTCBoxOfficeSaleEnd)) {
                return (
                    <React.Fragment>
                        {this.renderAvailability(date, i)}
                        <div className="showtix-event__dates__panel__item__title inactive">
                            <button
                                onClick={() => {
                                    this.props.toggleAllCategories();
                                    this.props.toggleAllDates();
                                    this.props.populateTicketSelection(this.props.event.id, i);
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: dateLabel
                                }}
                                id={`tooltip-availability-${date.id}`}
                                aria-label={`Buy tickets for ${dateLabel.replace('<br />', ' ')}`}
                            />
                        </div>
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        {this.renderAvailability(date, i)}
                        <div className="showtix-event__dates__panel__item__title">
                            <button
                                onClick={() => {
                                    this.props.toggleAllCategories();
                                    this.props.toggleAllDates();
                                    this.props.populateTicketSelection(this.props.event.id, i);
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: dateLabel
                                }}
                                id={`tooltip-availability-${date.id}`}
                                aria-label={`Buy tickets for ${dateLabel.replace('<br />', ' ')}`}
                            />
                        </div>
                    </React.Fragment>
                );
            }
        } else {
            let isInactive = !localUTC.isBetween(venueDateTimeUTCSaleStart, venueDateTimeUTCSaleEnd) && date.is_unlocked !== true;
            return (
                <React.Fragment>
                    {this.renderAvailability(date, i)}
                    <div className={"showtix-event__dates__panel__item__title" + (isInactive ? ' inactive' : '')}>
                        { isInactive ?
                            <span
                                id={`tooltip-availability-${date.id}`}
                                dangerouslySetInnerHTML={{
                                    __html: dateLabel
                                }}
                            />
                            :
                            <button
                                onClick={() => {
                                    this.props.toggleAllCategories();
                                    this.props.toggleAllDates();
                                    this.props.populateTicketSelection(this.props.event.id, i);
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: dateLabel
                                }}
                                id={`tooltip-availability-${date.id}`}
                                aria-label={`Buy tickets for ${dateLabel.replace('<br />', ' ')}`}
                            />
                        }
                    </div>
                </React.Fragment>
            );
        }
    }

    renderDateNotAvailable = (date, i) => {
        let timezone = this.props.event.venue ? ReturnTimeZone(this.props.event.venue.timezone || 'EST') : 'EST';
        if (timezone === 'Please select') {
            timezone = 'EST';
        }
        let timeStringSaleStart = moment(date.sale_start).tz(timezone).format().toString().substring(0, 19).replace('T', ' ');

        //let timeStringSaleEnd= date.sale_end.substring(0, 16).replace('T', ' ');

        /* let timeStringPreSaleStart = undefined;
        if (date.presale_start) {
            timeStringPreSaleStart = date.presale_start.substring(0, 16).replace('T', ' ');
        }

        let timeStringPreSaleEnd = undefined;
        if (date.presale_end) {
            timeStringPreSaleEnd = date.presale_end.substring(0, 16).replace('T', ' ');
        } */
        
        //let timeStringBoxOfficeSaleEnd= date.sale_end_box_office.substring(0, 16).replace('T', ' ');
        let venueDateTimeUTCSaleStart = moment(date.sale_start).tz(timezone); //moment.tz(timeStringSaleStart, timezone).utc();
        let venueDateTimeUTCSaleEnd = moment(date.sale_end).tz(timezone); //moment.tz(timeStringSaleEnd, timezone).utc();
        //let venueDateTimeUTCPreSaleStart = moment.tz(timeStringPreSaleStart, timezone).utc();
        //let venueDateTimeUTCPreSaleEnd = moment.tz(timeStringPreSaleEnd, timezone).utc();
        //let venueDateTimeUTCBoxOfficeSaleEnd = moment.tz(timeStringBoxOfficeSaleEnd, timezone).utc();
        let localUTC = moment().utc();
        let isPatron = this.props.user.role !== 'client' && this.props.user.role !== 'box-office';

        if(!localUTC.isBetween(venueDateTimeUTCSaleStart, venueDateTimeUTCSaleEnd)){
            // patrons only
            if(localUTC.isAfter(venueDateTimeUTCSaleEnd)){
                if(isPatron) {
                    return (
                        <span className="showtix-badge unavailable position-relative">
                            {strings.notAvailable}
                        </span>
                    );
                }
            // everyone
            } else {
                return (
                    <span className="showtix-badge unavailable position-relative">
                        {strings.salesStart}
                        {moment.utc(timeStringSaleStart).format('LLLL')}
                    </span>
                );
            }
        }
    }

    renderDatePresaleStarts  = (date, i) => {
        let timezone = this.props.event.venue ? ReturnTimeZone(this.props.event.venue.timezone || 'EST') : 'EST';
        if (timezone === 'Please select') {
            timezone = 'EST';
        }
        let timeStringPreSaleStart = undefined;
        if (date.presale_start) {
            timeStringPreSaleStart = date.presale_start.substring(0, 16).replace('T', ' ');
        }
        let timeStringPreSaleEnd = undefined;
        if (date.presale_end) {
            timeStringPreSaleEnd = date.presale_end.substring(0, 16).replace('T', ' ');
        }
        let venueDateTimeUTCPreSaleStart = moment(date.presale_start).tz(timezone); //moment.tz(timeStringPreSaleStart, timezone).utc();
        let localUTC = moment().utc();
        if (date.presale_password !== '' && localUTC.isBefore(venueDateTimeUTCPreSaleStart) && !moment(timeStringPreSaleStart).isSame(timeStringPreSaleEnd) ) {
            return (
                <span className="showtix-badge unavailable position-relative">
                    {strings.presaleStart}
                    {moment(date.presale_start).tz(timezone).format('LLLL')}
                </span>
            );
        }
        return null;
    }

    renderDateLabel = (date, i) => {
        let timezone = this.props.event.venue ? ReturnTimeZone(this.props.event.venue.timezone || 'EST') : 'EST';
        if (timezone === 'Please select') {
            timezone = 'EST';
        }
        //let timeStringSaleEnd = date.sale_end.substring(0, 16).replace('T', ' ');
        let venueDateTimeUTCSaleEnd = moment.tz(date.sale_end, timezone);//.utc();
        let localUTC = moment().utc();
        let publicSaleHaveEnded = localUTC.isAfter(venueDateTimeUTCSaleEnd);

        // logged-in user
        if((this.props.user.role === 'client' || this.props.user.role === 'box-office')) {
            if(this.props.category.name === 'active' && publicSaleHaveEnded) {
                return (
                    <span className="showtix-badge showtix-background__primary-4 position-relative">
                        {strings.publicSaleEnded}
                    </span>
                );
            }
        }
        return null;
    }

    renderDateUnlocked = (date, i) => {
        const timezone = this.props.event.venue ? ReturnTimeZone(this.props.event.venue.timezone || 'EST') : 'EST';
        /* let timeStringSaleStart = date.sale_start.substring(0, 16).replace('T', ' ');
        let timeStringSaleEnd= date.sale_end.substring(0, 16).replace('T', ' ');
        let timeStringPreSaleStart = undefined;
        if (date.presale_start) {
            timeStringPreSaleStart = date.presale_start.substring(0, 16).replace('T', ' ');
        }

        let timeStringPreSaleEnd = undefined;
        if (date.presale_end) {
            timeStringPreSaleEnd = date.presale_end.substring(0, 16).replace('T', ' ');
        }
        let timeStringBoxOfficeSaleEnd= date.sale_end_box_office.substring(0, 16).replace('T', ' ');
        let venueDateTimeUTCSaleStart = moment.tz(timeStringSaleStart, timezone).utc();
        let venueDateTimeUTCSaleEnd = moment.tz(timeStringSaleEnd, timezone).utc(); */
        let venueDateTimeUTCPreSaleStart = moment.tz(date.presale_start, timezone);
        let venueDateTimeUTCPreSaleEnd = moment.tz(date.presale_end, timezone);
        //let venueDateTimeUTCBoxOfficeSaleEnd = moment.tz(timeStringBoxOfficeSaleEnd, timezone).utc();
        let localUTC = moment().utc();

        if (date.is_unlocked) {
            return <span className="showtix-badge showtix-background__primary-4 position-relative">{strings.unlocked}</span>;
        }

        if (date.presale_password !== "" && localUTC.isBetween(venueDateTimeUTCPreSaleStart, venueDateTimeUTCPreSaleEnd) && date.is_unlocked !== true){
            if (this.props.user.role === 'client' || this.props.user.role === 'box-office') {
                return <span className="showtix-badge showtix-background__primary-4 position-relative">{strings.presale} - ({date.presale_password})</span>;
            } else {
                return (
                    <button
                        className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                        event_id={this.props.event.id}
                        date_id={date.id}
                        onClick={this.props.togglePassword}    
                    >
                        {strings.unlock}
                    </button>
                );
            }
        }
    }

    renderCredentials = (date) => {
        if (this.props.event.event_type === 'Live Stream') {
            let is90minBefore = this.is90minBefore(date);
            let is150minAfter = this.is150minAfter(date);
            let isClientVerified = this.props.client && this.props.client.verified;
            if (is90minBefore && !is150minAfter) {
                return (
                    <li className="js-credentials">
                        {!isClientVerified && (
                            <React.Fragment>
                                <span id={`tooltip-verified-2-${date.id}`} className="showtix-tooltip">!</span>
                                <Tooltip placement="top" target={`tooltip-verified-2-${date.id}`}>
                                    You need to be verified before setting up your Video
                                </Tooltip>
                            </React.Fragment>
                        )}
                        <button
                            disabled={!isClientVerified}
                            onClick={() => this.props.getCredentials(date.id)}
                        >
                            {strings.credentials}
                        </button>
                    </li>
                );
            } else {
                return (
                    <li className="js-credentials">
                        <React.Fragment>
                            <span id={`tooltip-verified-2-${date.id}`} className="showtix-tooltip">!</span>
                            <Tooltip placement="top" target={`tooltip-verified-2-${date.id}`}>
                                Access to credentials is available 90 minutes prior through 150 minutes after event.
                            </Tooltip>
                        </React.Fragment>
                        <button
                            disabled={true}
                            onClick={() => this.props.getCredentials(date.id)}
                        >
                            {strings.credentials}
                        </button>
                    </li>
                );
            }
            
        }
    };

    renderAvailability = (date, i) => {
        if (this.props.event.event_type === 'Video On Demand') {
            let timezone = this.props.event.venue.timezone;
            if (date.redeem_start && date.redeem_end) {
                return (
                    <Tooltip placement="top" target={`tooltip-availability-${date.id}`}>
                    Video Available {moment(date.redeem_start).tz(timezone).format('LLLL')} - {moment(date.redeem_end).tz(timezone).format('LLLL')}
                    </Tooltip>
                )
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    renderStream = (date) => {
        if (this.props.user.role === 'box-office' || this.props.user.role === 'client') {
            if (this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') {
                const is120minBefore = this.is120minBefore(date);
                const eventTypeUrl = this.props.event.event_type.toLowerCase().replace(/\s/g, '-');
                return (
                    <li><Link to={`/stream?event_date_id=${date.id}&event_id=${date.event_id}&eventType=${eventTypeUrl}&is120minBefore=${is120minBefore}`} target="_blank">{strings.player}</Link></li>
                );
            }
        }
    };

    renderSubMenu = (date, i) => {
        return (
            <div 
                ref={node => this.node = node}
                className={"showtix-event__panel showtix-event__settings__panel showtix-background__grey-3" + (date.isDateSettingsOpen ? ' is-active' : '')}>
                <ul>
                    {(this.props.event.status === 'pending' || this.props.event.status === 'active') && (
                        this.renderStream(date)
                    )}
                    {this.props.event.status !== 'pending' && (
                        <React.Fragment>
                            <li><Link to={`/search/date/${date.id}`}>{strings.transactionsSearch}</Link></li>
                            <li><button
                                onClick={() => this.props.getSeatingReport(date.id)}
                            >{strings.eventSeatingReport}</button></li>
                        </React.Fragment>
                    )}
                    {this.renderCredentials(date)}
                    {this.props.event.status === 'active' && (
                        <React.Fragment>
                            <li>
                                <button
                                    name="house-count-button"
                                    onClick={() => this.props.getHouseCount(date.id)}
                                >
                                    {strings.houseCount}
                                </button>
                                {date.total_count !== undefined && (
                                    <div className="showtix-event__house-count">
                                        <ul>
                                            <li>
                                                {strings.available}: {date.total_count-date.held_count}
                                            </li>
                                            <li>
                                                {strings.held}: {date.held_count} ({((date.held_count/date.total_count)*100).toFixed(2)}%)
                                            </li>
                                            <li>
                                                {strings.total}: {date.total_count}
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </li>    
                            {(this.props.event.event_type !== 'Live Stream' && this.props.event.event_type !== 'Scheduled Content' && this.props.event.event_type !== 'Video On Demand') && (
                                <React.Fragment>
                                    <li><Link to={`/checkin/${this.props.event.id}/${date.id}`}>{strings.checkinSystem}</Link></li>
                                    <li>
                                        <button
                                            onClick={(e) => this.toggleAlertModal(e, date)}
                                        >
                                            <img src={printIcon} alt='' /> 
                                            {strings.printWillCallTicketsDymo}
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={() => this.printWillCallDymoPDF(date)}
                                        >
                                            <img src={printIcon} alt='' /> 
                                            {strings.printWillCallTicketsDymoPDF}
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={(e) => this.toggleAlertModalBoca(e, date)}
                                        >
                                            <img src={printIcon} alt='' />
                                            {strings.printWillCallTicketsBoca}
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={(e) => this.props.printersStar.length === 0 || this.props.printersStar.length >= 1 ? this.toggleAlertModalStar(e, date) : this.printWillCallTicketsStar(date.id)}
                                        >
                                            <img src={printIcon} alt='' />
                                            {strings.printWillCallTicketsStar}
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={() => this.printWillCallTickets(date.id)}
                                        >
                                            <img src={printIcon} alt='' /> 
                                            {strings.printWillCallTickets}
                                        </button>
                                    </li>
                                </React.Fragment>
                            )}
                            
                        </React.Fragment>
                    )}
                </ul>
            </div>
        );
    }

    renderDateSettingsButton = (date, i) => {
        if (this.props.user.role) {
            if (this.props.user.client_id === this.props.current_client_id || !this.props.current_client_id) {
                if ((this.props.event.event_type === 'Live Stream' && this.props.event.status === 'pending') || (this.props.event.event_type === 'Event' && this.props.event.status === 'pending')) {
                    return null;
                } else {
                    return (
                        <button
                            id={`dates-settings-b-${this.props.event.id}-${i}`}
                            className="showtix-event__settings showtix-background__grey-3"
                            onClick={() => {
                                this.props.toggleDateSettings(this.props.event.id, i); 
                                this.setCurrentIndex(i);
                            }}
                        >
                            <img
                                id={`dates-settings-i-${this.props.event.id}-${i}`}
                                src={settingsIcon} alt="Click here to open the Event Date Settings" />
                        </button>
                    );
                }
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    hasEventsToDisplay = (dates) => {
        let eventsToDisplay = true;
        let isPatron = this.props.user.role !== 'client' && this.props.user.role !== 'box-office';
        let nbEventsNotPassed = dates.length;

        if (this.props.event.venue) {
            if(isPatron) {
                dates.map(date => {
                    let publicSaleHaveEnded = this.hasPublicSaleHaveEnded(date, this.props.event.venue.timezone);
                    if(publicSaleHaveEnded) {
                        nbEventsNotPassed--;
                    }
                });
                eventsToDisplay = nbEventsNotPassed > 0;
            }
        }
        return eventsToDisplay;
    }

    hasPublicSaleHaveEnded = (date, timezoneString) => {
        if (this.props.event.venue) {
            let timezone = this.props.event.venue ? ReturnTimeZone(this.props.event.venue.timezone || 'EST') : 'EST';
            let timeStringEventEnd = date.sale_end.substring(0, 16).replace('T', ' ');
            let venueDateTimeUTCEventEnd = moment.tz(timeStringEventEnd, timezone).utc();
            let localUTC = moment().utc();
            let publicSaleHaveEnded = localUTC.isAfter(venueDateTimeUTCEventEnd);
            return publicSaleHaveEnded;
        }
    }

    is90minBefore = (date) => {
        if (this.props.event.venue) {
            let timezone = this.props.event.venue ? ReturnTimeZone(this.props.event.venue.timezone || 'EST') : 'EST';
            let timeStringEvent = date.event_datetime_local.substring(0, 16).replace('T', ' ');
            let venueDateTimeUTCEvent = moment.tz(timeStringEvent, timezone).utc();
            let localUTC = moment().utc();
            let is90minBefore = moment.duration(venueDateTimeUTCEvent.diff(localUTC)).asMinutes() < 90;
            return is90minBefore;
        }
    }

    is120minBefore = (date) => {
        if (this.props.event.venue) {
            let timezone = this.props.event.venue ? ReturnTimeZone(this.props.event.venue.timezone || 'EST') : 'EST';
            let timeStringEvent = date.event_datetime_local.substring(0, 16).replace('T', ' ');
            let venueDateTimeUTCEvent = moment.tz(timeStringEvent, timezone).utc();
            let localUTC = moment().utc();
            let is120minBefore = moment.duration(venueDateTimeUTCEvent.diff(localUTC)).asMinutes() < 120;
            return is120minBefore;
        }
    }

    is150minAfter = (date) => {
        if (this.props.event.venue) {
            let timezone = this.props.event.venue ? ReturnTimeZone(this.props.event.venue.timezone || 'EST') : 'EST';
            let timeStringEvent = date.event_datetime_local.substring(0, 16).replace('T', ' ');
            let venueDateTimeUTCEvent = moment.tz(timeStringEvent, timezone).utc();
            let localUTC = moment().utc();
            let is150minAfter = moment.duration(venueDateTimeUTCEvent.diff(localUTC)).asMinutes() < -150;
            return is150minAfter;
        }
    }

    componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    render() {
        let hasEventsToDisplay = this.hasEventsToDisplay(this.props.event.event_dates);
        let isPatron = this.props.user.role !== 'client' && this.props.user.role !== 'box-office';
        let showDatesLabel = strings.purchase;
        if (this.props.event.event_type === 'Video On Demand') {
            showDatesLabel = strings.rentVideo;
        }
        if (this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Schedule Content') {
            showDatesLabel = strings.buyStream;
        }
        if (this.props.event.event_type === 'Event') {
            showDatesLabel = strings.buyTickets;
        }
        let eventTimezone = 'EST';
        if (this.props.event.venue) {
            eventTimezone = this.props.event.venue.timezone;
        }
        return ( 
            <React.Fragment>
                <AlertModal
                    isModalOpen={this.state.isModalOpen}
                    toggleAlertModal={this.toggleAlertModal}
                    confirmAlertModal={this.confirmAlertModal}
                    modalTitle={strings.modalTitle}
                    modalDescription={this.props.printerSelect()}
                    disabled={this.props.printers.length < 1}
                />
                <AlertModal
                    isModalOpen={this.state.isModalOpenBoca}
                    toggleAlertModal={this.toggleAlertModalBoca}
                    confirmAlertModal={this.confirmAlertModalBoca}
                    modalTitle={strings.modalTitle}
                    modalDescription={this.props.printerSelectBoca()}
                    disabled={this.props.printersBoca.length < 1}
                />
                <AlertModalStar
                    isModalOpenStar={this.state.isModalOpenStar}
                    toggleAlertModalStar={this.toggleAlertModalStar}
                    confirmAlertModalStar={this.confirmAlertModalStar}
                    modalDescription={this.printerSelectStar()}
                    printersStar={this.props.printersStar}
                />
                <div className="showtix-event__dates">
                    <button
                        className="showtix-button showtix-background__primary-2"
                        onClick={() => this.props.toggleDate(this.props.event.id)}
                        aria-expanded={this.props.event.isDateOpen}
                        aria-controls={`dates-event-${this.props.event.id}`}
                    >{showDatesLabel}</button>
                    <div
                        className={"showtix-event__dates__panel showtix-background__primary-2" + (this.props.event.isDateOpen ? ' is-active' : '')}
                        id={`dates-event-${this.props.event.id}`}
                    >
                        <ul>
                            {!hasEventsToDisplay &&
                                <p className="showtix-event__dates__panel__item__subtitle">{strings.noDates}</p>
                            }
                            {hasEventsToDisplay &&
                            <React.Fragment>
                            {
                                this.props.event.event_dates.map((date, i) => {
                                    if(!(isPatron && this.hasPublicSaleHaveEnded(date, eventTimezone))) {
                                        return (
                                            <li className="showtix-event__dates__panel__item" key={i}>
                                                {this.renderDateSettingsButton(date, i)}
                                                <div>
                                                    {this.renderDate(date, i)}
                                                    <p className="showtix-event__dates__panel__item__subtitle">{date.event_subtitle}</p>
                                                    {this.renderDatePresaleStarts(date, i)}
                                                    {this.renderDateNotAvailable(date, i)}
                                                    {this.renderDateLabel(date, i)}
                                                    {this.renderDateUnlocked(date, i)}
                                                </div>
                                                {this.renderSubMenu(date, i)}
                                            </li>
                                        )
                                    } else {
                                        return null;
                                    }
                                })
                            }
                            </React.Fragment>
                            }
                        </ul>
                    </div>
                </div>
            </React.Fragment>
         )
    }
}

EventDates.propTypes = {
    event: PropTypes.shape({
        id: PropTypes.number,
        status: PropTypes.string,
        event_dates: PropTypes.array,
        isDateOpen: PropTypes.bool
    }),
    is_client: PropTypes.bool,
    toggleDateSettings: PropTypes.func,
    toggleDate: PropTypes.func,
    toggleAllCategories: PropTypes.func,
    toggleAllDates: PropTypes.func,
    populateTicketSelection: PropTypes.func
}
 
export default EventDates;



// WEBPACK FOOTER //
// ./src/components/EventListing/Event/EventDates/EventDates.js